import { getMyOpenConversationIds } from 'conversations/modules/conversation/selectors'
import { FEEDBACK_LAST_OPEN_KEY, lastOpenTime } from 'conversations/modules/modal/selectors'
import { Epic } from 'redux-observable'
import { filter, map } from 'rxjs/operators'
import { updateConversationStatusAsync } from 'shared/store/actions/conversation'
import { showFeedbackModal } from 'shared/store/actions/modal'
import { ConversationStatus } from 'shared/typings/conversations/status/ConversationStatus'
import { isStorageSupported, localStore } from 'shared/utils/storage'

import { isActionOf, RootAction, RootState } from 'typesafe-actions'

const NEW_CHAT_SIDEBAR_LAUNCH_TIME = 1618804800000 // April 19th 2021

export const triggerFeedbackModalEpic: Epic<RootAction, RootAction, RootState> = (
  action$,
  state
) => {
  return action$.pipe(
    filter(isActionOf(updateConversationStatusAsync.request)),
    filter(({ payload }) => {
      const myOpenConversations = getMyOpenConversationIds(state.value)
      return (
        myOpenConversations.length === 1 &&
        myOpenConversations[0] === payload.conversationId &&
        payload.conversationStatus === ConversationStatus.CLOSED
      )
    }),
    filter(() => isStorageSupported('localStorage')),
    filter(() => lastOpenTime() < NEW_CHAT_SIDEBAR_LAUNCH_TIME),
    map(() => {
      localStore.set(FEEDBACK_LAST_OPEN_KEY, new Date().getTime())
      return showFeedbackModal({ manual: false })
    })
  )
}
